import dayjs from 'dayjs';
import { formatDate } from 'views/order-feed/features/my-supply-plan/utils/order-utils';
import { DispatchSchedule } from 'views/order-feed/types/shipping-schedule.type';

const DispatchScheduleWithoutScheduleData: DispatchSchedule = {
  earliestPossibleDispatchDate: formatDate(dayjs().add(5, 'days').toISOString()),
  dispatchDateData: [],
  isUnsupportedShippingSchedule: false,
};

const DispatchScheduleWithScheduleData: DispatchSchedule = {
  earliestPossibleDispatchDate: formatDate(dayjs().add(5, 'days').toISOString()),
  dispatchDateData: [
    {
      dispatchDate: formatDate(dayjs().add(3, 'days').toISOString()),
      estimatedArrivalDate: formatDate(dayjs().add(10, 'days').toISOString()),
      factory: 'Test Factory 0',
      factoryId: 'tf00',
      vessel: 'Test Vessel 0',
    },
    {
      dispatchDate: formatDate(dayjs().add(7, 'days').toISOString()),
      estimatedArrivalDate: formatDate(dayjs().add(14, 'days').toISOString()),
      factory: 'Test Factory 1',
      factoryId: 'tf01',
      vessel: 'Test Vessel 1',
    },
    {
      dispatchDate: formatDate(dayjs().add(11, 'days').toISOString()),
      estimatedArrivalDate: formatDate(dayjs().add(18, 'days').toISOString()),
      factory: 'Test Factory 2',
      factoryId: 'tf02',
      vessel: 'Test Vessel 2',
    },
    {
      dispatchDate: formatDate(dayjs().add(15, 'days').toISOString()),
      estimatedArrivalDate: formatDate(dayjs().add(22, 'days').toISOString()),
      factory: 'Test Factory 3',
      factoryId: 'tf03',
      vessel: 'Test Vessel 3',
    },
    {
      dispatchDate: formatDate(dayjs().add(19, 'days').toISOString()),
      estimatedArrivalDate: formatDate(dayjs().add(26, 'days').toISOString()),
      factory: 'Test Factory 4',
      factoryId: 'tf04',
      vessel: 'Test Vessel 4',
    },
  ],
  isUnsupportedShippingSchedule: false,
};

export { DispatchScheduleWithoutScheduleData, DispatchScheduleWithScheduleData };
